<template>
  <div
    class="flex flex-wrap p-2 rounded-md shadow-md cursor-pointer"
    style="background-color: transparent;"
  >
    <div v-if="$slots.left" class="self-start flex items-center">
      <slot name="left" />
    </div>
    <div class="flex-1 px-4 text-left flex items-center">
      <slot />
    </div>
    <div v-if="$slots.right" class="flex items-center">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Row",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      import_to_file: ""
    };
  },
  created() {}
};
</script>

<style></style>
